import React from 'react';
import Button from '@mui/material/Button';

import classNames from 'classnames';
import styles from './PrimaryButton.module.css';

const PrimaryButton = ({children, className, ...props}) => {
  return (
    <Button className={classNames(styles.customButton, className)} {...props}>
      {children}
    </Button>
  );
};

export default PrimaryButton;
